<template>
    <div>
        <app-sub-title
            :text="'Reuniones del cliente ' + theClient.name"
        ></app-sub-title>
        <b-button
            variant="primary"
            @click="startSaveReport"
            class="btn-block-xs-only"
            ><i class="fa fa-plus"></i> Iniciar nueva reunión</b-button
        >
        <b-tabs>
            <b-tab title="Confirmadas" active>
                <b-card>
                    <app-contact-reports-filters @filter="onFilter" />
                    <app-contact-reports-list
                        :data="data"
                        @change-page="changePage"
                        @see-details-report="seeDetails"
                        @update-report="startUpdate"
                        @remove-report="startRemove"
                        @add-photos-report="startAddPhotos"
                        @sort="onSort"
                        @add-watchers="startAddWatchers"
                    />
                </b-card>
            </b-tab>
            <b-tab title="Borradores">
                <b-card>
                    <app-contact-reports-filters @filter="onFilterDraft" />
                    <app-contact-reports-list
                        :data="drafts"
                        @change-page="changePageDrafts"
                        @see-details-report="seeDetails"
                        @update-report="startUpdate"
                        @remove-report="startRemove"
                        @add-photos-report="startAddPhotos"
                        @sort="onSortDrafts"
                    />
                </b-card>
            </b-tab>
        </b-tabs>

        <!-- Inicio pop up's -->
        <app-pop-up title="Confirmación" id="report-remove">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea eliminar este reporte de reunión?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    variant="primary"
                    class="btn-block-xs-only"
                    @click="deleteReport(selectReport)"
                    ><i class="fa fa-trash-o"></i> Confirmar
                    Eliminación</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up
            :title="
                `Reunion: ${selectReport.code} - Fecha: ${moment(
                    selectReport.meeting_date
                ).format('DD/MM/YYYY HH:mm:ss')}`
            "
            id="see-report"
            size="extra-large"
        >
            <div slot="body">
                <b-tabs>
                    <b-tab title="Información detallada" active>
                        <b-card
                            v-if="selectReport"
                            tag="article"
                            style="max-width: 100%;"
                            class="mb-2"
                        >
                            <div class="card-text">
                                <b-row>
                                    <b-col class="pb-3" cols="12" md="4">
                                        <h5>Cliente</h5>
                                        {{ client.name }}
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        v-if="selectReport.participants.length"
                                    >
                                        <h5>Reportado por</h5>
                                        {{ selectReport.reported_by.name }}
                                    </b-col>
                                    <b-col class="pb-3" cols="12" md="4">
                                        <h5>Participantes</h5>
                                        <div
                                            v-for="participant in selectReport.participants"
                                            :key="participant.name"
                                        >
                                            <div>
                                                - {{ participant.name }} ({{
                                                    participant.email
                                                }})
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        v-if="selectReport.watchers.length"
                                    >
                                        <h5>Compartido con</h5>
                                        <div
                                            v-for="watcher in selectReport.watchers"
                                            :key="watcher.id"
                                        >
                                            <div>
                                                -
                                                <a
                                                    :href="
                                                        `mailto:${watcher.user.email}`
                                                    "
                                                    >{{ watcher.user.name }} ({{
                                                        watcher.user.position
                                                            .name
                                                    }})</a
                                                >
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col class="pb-3" cols="12">
                                        <h5>Descripción de la reunión</h5>
                                        <div class="notebook">
                                            <span
                                                v-html="
                                                    selectReport.description_formated
                                                "
                                            ></span>
                                        </div>
                                    </b-col>
                                    <b-col class="pb-3" cols="12">
                                        <h5>Notas internas</h5>
                                        <div class="notebook-blue">
                                            <span
                                                v-html="
                                                    selectReport.internal_notes
                                                "
                                            ></span>
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        cols="12"
                                        v-if="
                                            selectReport.petitions.length &&
                                                !selectReport.draft
                                        "
                                    >
                                        <h5>Peticiones</h5>
                                        <div
                                            v-for="petition in selectReport.petitions"
                                            :key="petition.id"
                                        >
                                            <div>
                                                - ({{
                                                    petition.petition_type.name
                                                }}) {{ petition.description }}
                                            </div>
                                            <br />
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        cols="12"
                                        v-if="
                                            selectReport.petition_drafts
                                                .length && selectReport.draft
                                        "
                                    >
                                        <h5>Peticiones borradores</h5>
                                        <div
                                            v-for="petition in selectReport.petition_drafts"
                                            :key="petition.id"
                                        >
                                            <div>
                                                - ({{
                                                    petition.petition_type.name
                                                }}) {{ petition.description }}
                                            </div>
                                            <br />
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        cols="12"
                                        v-if="tasks.length"
                                    >
                                        <b>Lista de Tareas:</b>
                                        <div class="table-responsive-sm">
                                            <table
                                                class="table table-hover table-bordered table-sm"
                                            >
                                                <thead class="thead-orange">
                                                    <tr class="x-d-flex">
                                                        <th>Tarea</th>
                                                        <th>Descripcion</th>
                                                        <th>Asignado a</th>
                                                        <th>
                                                            Fecha de vencimiento
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="task in selectReport.tasks"
                                                        :key="task.id"
                                                    >
                                                        <td>
                                                            {{ task.name }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                task.description
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                task.assignee
                                                                    .name
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{ task.due_date }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-tab>
                    <b-tab
                        title="Fotos"
                        v-if="!!selectReport && selectReport.photos.length"
                    >
                        <app-sub-title text="Fotos" />
                        <b-carousel
                            id="report-photos"
                            controls
                            indicators
                            :interval="4000"
                            v-model="slide"
                        >
                            <b-carousel-slide
                                v-for="photo in selectReport.photos"
                                :key="photo.id"
                                :img-src="photo.photo_url"
                            />
                        </b-carousel>
                    </b-tab>
                </b-tabs>
            </div>
        </app-pop-up>

        <app-pop-up title="Agregar fotos" id="add-photos-report">
            <div slot="body">
                <b-card tag="article" style="max-width: 100%;" class="mb-2">
                    <div class="card-text">
                        <app-upload-or-take-photo
                            id="add-report-photos"
                            title="Fotos de la reunión"
                            v-model="files"
                        />
                        <div v-if="files">
                            <button
                                class="btn btn-sm btn-danger pull-right"
                                @click="cancelFilesSelected"
                            >
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                Cancelar archivos seleccionados
                            </button>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    variant="primary"
                    class="btn-block-xs-only"
                    :disabled="!files ? !files : inProgress"
                    @click="savePhotos(selectReport)"
                    ><i class="fa fa-floppy-o"></i> Guardar fotos</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar destinatarios"
            id="add-watcher-report"
            :onClose="cleanWatcherForm"
        >
            <div slot="body">
                <app-assign-watcher-to-the-report
                    v-if="selectReport"
                    id="add-watcher-report"
                    :report-id="selectReport.id"
                    :on-save="onAssignWatchers"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('add-watcher-report.save')"
                >
                    Asignar
                </button>
            </div>
        </app-pop-up>

        <!-- Fin pop up's -->
    </div>
</template>

<script>
import ContactReportsList from './ContactReportsList/ContactReportsList.vue'
import ContactReportsFilters from './ContactReportsFilters/ContactReportsFilters.vue'
import contactsRepository from '../../../../repositories/contacts.repository.js'
import UploadOrTakePhoto from '../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import AssignWatcherToTheReport from './AssignWatcher/AssignWatcherToTheReport.vue'

export default {
    components: {
        appContactReportsList: ContactReportsList,
        appContactReportsFilters: ContactReportsFilters,
        appUploadOrTakePhoto: UploadOrTakePhoto,
        appAssignWatcherToTheReport: AssignWatcherToTheReport,
    },

    props: {
        theClient: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {},
            drafts: {},
            filters: {},
            page: 1,
            selectReport: '',
            slide: 1,
            files: '',
            sort: {
                sortBy: 'meeting_date',
                sortDir: 'desc',
            },
            sortDraft: {
                sortBy: 'meeting_date',
                sortDir: 'desc',
            },
            tasks: [],
        }
    },
    methods: {
        loadReports() {
            const cr = { ...contactsRepository }
            const filters = {
                ...this.filters,
                clientId: this.theClient.id,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                state: 0,
            } //se cargan solo los reportes del cliente
            cr.getReports(filters, this.page)
                .then(data => (this.data = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los reportes del cliente'
                    )
                )
        },
        loadDraftReports() {
            const cr = { ...contactsRepository }
            const filters = {
                ...this.filtersDraft,
                reportedById: this.user.id,
                clientId: this.theClient.id,
                sortBy: this.sortDraft.sortBy,
                sortDir: this.sortDraft.sortDir,
                state: 1,
            } //se cargan solo los reportes (borradores) del cliente y usuario logueado
            cr.getReports(filters, this.page)
                .then(data => (this.drafts = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los reportes del cliente'
                    )
                )
        },
        onFilter(filters) {
            this.filters = filters
            this.loadReports()
        },
        onFilterDraft(filters) {
            this.filtersDraft = filters
            this.loadDraftReports()
        },
        changePage(page) {
            this.page = page
            this.loadReports()
        },
        changePageDrafts(page) {
            this.page = page
            this.loadDraftReports()
        },
        startSaveReport() {
            this.$router.push({
                name: 'contactReportForm',
                params: { clientId: this.theClient.id, isSave: true },
            })
        },
        seeDetails(report) {
            this.selectReport = report
            this.tasks = report.tasks
            this.$bus.$emit('see-report.open')
        },
        startUpdate(report) {
            // isSave = true => Creando, false => editando
            this.$router.push({
                name: 'contactReportForm',
                params: {
                    clientId: this.theClient.id,
                    report: report,
                    isSave: false,
                },
            })
        },
        startRemove(report) {
            console.log(report)
            this.selectReport = report
            this.$bus.$emit('report-remove.open')
        },
        startAddPhotos(report) {
            this.selectReport = report
            this.$bus.$emit('add-photos-report.open')
        },
        startAddWatchers(report) {
            this.selectReport = report
            this.$bus.$emit('add-watcher-report.open')
        },
        deleteReport(report) {
            const cr = { ...contactsRepository }
            cr.deleteContactReport(report.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.initialize()
                        this.$bus.$emit('report-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el reporte de la reunión')
                })
        },
        cancelFilesSelected() {
            this.$bus.$emit('add-report-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        savePhotos() {
            const formData = new FormData()

            formData.append('contactReportId', this.selectReport.id)

            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }

            const cr = { ...contactsRepository }
            cr.saveContactReportPhotos(formData)
                .then(data => {
                    if (data.status) {
                        this.initialize()
                        toastr.success(data.msg)
                        this.$bus.$emit('add-photos-report.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al guardar las fotos de la reunión')
                })
        },
        onAssignWatchers() {
            this.$bus.$emit('add-watcher-report.close')
            this.loadReports()
        },
        cleanWatcherForm() {
            this.$bus.$emit('add-watcher-report.clean')
        },
        initialize() {
            this.loadReports()
            this.loadDraftReports()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadReports()
        },
        onSortDrafts(ctx) {
            this.sortDraft.sortBy = ctx.sortBy
            this.sortDraft.sortDir = ctx.sortDir
            this.loadDraftReports()
        },
    },
    created() {
        this.initialize()
    },
}
</script>
